import { render, staticRenderFns } from "./privateAutoAnswer.vue?vue&type=template&id=3b235615"
import script from "./privateAutoAnswer.vue?vue&type=script&lang=js"
export * from "./privateAutoAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports